import { type FC } from 'react';
import { FormattedNumber, useIntl } from 'react-intl';

import { isLegacyPlan } from '../../../../../lib/isLegacyPlan';
import { Quota, type QuotaProps } from '../components/Quota';
import { useQuota } from '../context';

export type MastercardBusinessWorldDebitQuotaProps = QuotaProps;

export const MastercardBusinessWorldDebitQuota: FC<
  MastercardBusinessWorldDebitQuotaProps
> = (props) => {
  const { fees, planId, planName, quotas } = useQuota();
  const intl = useIntl();

  const quota = quotas.businessWorldDebitCardQuota;
  const fee = fees.additionalPhysicalPaymentCard;
  const exceeding = 0;

  const locales = {
    additional_fee: intl.formatMessage(
      {
        id: 'subscription.overview.quotas.mastercard_business_world_debit.additional_fee',
      },
      {
        monthly: fees.additionalPhysicalPaymentCardMonth.fixed / 100,
      },
    ),
    description: intl.formatMessage(
      {
        id: 'subscription.overview.quotas.mastercard_business_world_debit.description',
      },
      {
        limit: quota.limit,
        plan: planName,
        used: quota.used,
      },
    ),
    exceeding: intl.formatMessage(
      {
        id: 'subscription.overview.quotas.exceeding',
      },
      {
        exceeding,
      },
    ),
    label: intl.formatMessage({
      id: 'subscription.overview.quotas.mastercard_business_world_debit.label',
    }),
    legacy_additional_fee: intl.formatMessage(
      {
        id: 'subscription.overview.quotas.mastercard_business_world_debit.additional_fee.legacy',
      },
      {
        fixed: (
          <FormattedNumber
            currency="EUR"
            style="currency"
            value={fee.fixed / 100}
          />
        ),
      },
    ),
  };

  return (
    <Quota isExpandable {...props}>
      <Quota.Body>
        <Quota.Progress
          icon="card-verso"
          max={quota.limit}
          value={quota.used}
        />

        <Quota.Content>
          <Quota.Label>{locales.label}</Quota.Label>
          <Quota.Description>{locales.description}</Quota.Description>
        </Quota.Content>

        {/* TODO: fetch exceeding quota once available from billing-service */}
        {/* <Quota.Exceeding>{locales.exceeding}</Quota.Exceeding> */}
      </Quota.Body>

      <Quota.Footer>
        <Quota.AdditionalFees>
          {isLegacyPlan(planId)
            ? locales.legacy_additional_fee
            : locales.additional_fee}
        </Quota.AdditionalFees>
      </Quota.Footer>
    </Quota>
  );
};
